var gql = require("@apollo/client").gql;

const DISTRICTS_COMMON_QUERY = gql`
	query Districts($filter: String, $regionUrl: String) {
		districts: districts(region_url: $regionUrl, filter: $filter) {
			data {
				id
				parentId
				name
				service
			}
		}
		settlements: districts(region_url: $regionUrl, filter: $filter) {
			settlements {
				id
				name
				full
				type
				district {
					id
					name
					service
				}
				region {
					id
					name
				}
			}
		}
	}
`;

module.exports = DISTRICTS_COMMON_QUERY;
